var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';
export default function ListsIcon(_a) {
    var { size = 'small' } = _a, rest = __rest(_a, ["size"]);
    return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, width: sizes[size], height: sizes[size] }, rest, { viewBox: "0 0 20 20" }),
        jsx("g", { id: "4-(S---20px)/Lists", stroke: "currentColor", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "square" },
            jsx("line", { x1: "6.5", y1: "5.5", x2: "17.5", y2: "5.5" }),
            jsx("line", { x1: "6.5", y1: "9.5", x2: "17.5", y2: "9.5" }),
            jsx("line", { x1: "6.5", y1: "13.5", x2: "17.5", y2: "13.5" }),
            jsx("line", { x1: "6.5", y1: "17.5", x2: "17.5", y2: "17.5" }),
            jsx("path", { d: "M3,6 C3.2911613,6 3.48793864,6 3.59033203,6 C3.86344401,6 4,6 4,6", strokeWidth: "2" }),
            jsx("path", { d: "M3,10 C3.2911613,10 3.48793864,10 3.59033203,10 C3.86344401,10 4,10 4,10", strokeWidth: "2" }),
            jsx("path", { d: "M3,14 C3.2911613,14 3.48793864,14 3.59033203,14 C3.86344401,14 4,14 4,14", strokeWidth: "2" }),
            jsx("path", { d: "M3,18 C3.2911613,18 3.48793864,18 3.59033203,18 C3.86344401,18 4,18 4,18", strokeWidth: "2" }))));
}
//# sourceMappingURL=ListsIcon.js.map